export const authRole = {
  admin: ['user', 'admin'],
  user: ['user'],
};

export const RoutePermittedRole = {
  admin: 'admin',
  user: 'user',
};

export const ThemeStyle = {
  MODERN: 'modern',
  STANDARD: 'standard',
};

export const ThemeMode = {
  LIGHT: 'light',
  SEMI_DARK: 'semi-dark',
  DARK: 'dark',
};

export const LayoutType = {
  FULL_WIDTH: 'full-width',
  BOXED: 'boxed',
  FRAMED: 'framed',
};

export const MenuStyle = {
  DEFAULT: 'default',
  STANDARD: 'standard',
  ROUNDED: 'rounded',
  ROUNDED_REVERSE: 'rounded-reverse',
  CURVED_MENU: 'curved-menu',
};

export const NavStyle = {
  DEFAULT: 'default',
  MINI: 'mini',
  MINI_SIDEBAR_TOGGLE: 'mini-sidebar-toggle',
  STANDARD: 'standard',
  HEADER_USER: 'user-header',
  HEADER_USER_MINI: 'user-mini-header',
  DRAWER: 'drawer',
  BIT_BUCKET: 'bit-bucket',
  H_DEFAULT: 'h-default',
  HOR_HEADER_FIXED: 'hor-header-fixed',
  HOR_DARK_LAYOUT: 'hor-dark-layout',
};
export const FooterType = {
  FIXED: 'fixed',
  FLUID: 'fluid',
};
export const ThemeDirection = {
  RTL: 'rtl',
  LTR: 'ltr',
};

export const UploadType = {
  PICTURE: 'PICTURE',
  ICON: 'ICON',
  FILE: 'FILE',
  SMALLPICTURE: 'SMALLPICTURE',
};

export enum DaysOfWeek {
  Sunday = 0,
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6,
}

export enum NotificationTypeValue {
  CareRequest = 1,
  ClaimBusinessProfileRequest = 2,
  CaregiverRequest = 3,
}

export enum CompanyOwnStatus {
  WithoutAccount = 1,
  Claimed = 2,
}

export const CompanyPositions = {
  Owner: 1,
  Founder: 2,
  CEO: 3,
  OP: 4,
  CaseManager: 5,
  Other: 6,
};

export const CareRequestStatus = {
  New: 1,
  Contacted: 2,
  Connected: 3,
  Unresponsive: 4,
  Closed: 5,
};
